import React from 'react';

import classNames from './EABDStartJourneyCircle.module.scss';
import { Button } from 'ui/component';
import { StyleUtil } from 'ui/util';

export interface StartJourneyCircleProps
  extends Readonly<{
    onButtonPress: () => void;
  }> {}

export const StartJourneyCircle = React.memo<StartJourneyCircleProps>((props) => {
  const { onButtonPress } = props;

  const RenderRotatedAtomCallback = React.useCallback((rotatedClassName: string) => {
    const rotatedClassNames: string[] = [classNames.rotated, classNames[rotatedClassName]];

    return (
      <div className={StyleUtil.mergeClassNames(rotatedClassNames)}>
        <div className={classNames.atom}>
          <div className={classNames.core} />
        </div>
      </div>
    );
  }, []);

  const ContentElement = React.useMemo(() => {
    return (
      <div className={classNames.content}>
        <p className={classNames.title}>
          Learn about the
          <br />
          evolution of our journey
        </p>
        <p className={classNames.body}>
          From <span className={classNames.emphasized}>reactive</span>, incident-driven
          <br />
          to <span className={classNames.emphasized}>proactive</span>, data-driven
        </p>
        <Button useLargerFontSize={true} onPress={onButtonPress}>
          Start
        </Button>
      </div>
    );
  }, [onButtonPress]);

  return (
    <div className={classNames.container}>
      <div className={classNames.circle}></div>
      <div className={classNames.rotatedWrapper}>
        {RenderRotatedAtomCallback('top')}
        {RenderRotatedAtomCallback('topLeft')}
        {RenderRotatedAtomCallback('topRight')}
        {RenderRotatedAtomCallback('bottomLeft')}
        {RenderRotatedAtomCallback('bottomRight')}
      </div>
      <div className={classNames.filledCircle}>{ContentElement}</div>
    </div>
  );
});
